import { orderConstants } from "../constants";
import { orderService } from "../../services";

export const orderActions = {
  ordersList,
  orderData,
  orderPayments,
  orderUpdate,
};

/*
ACTION: Orders List
*/
function ordersList(
  pageID,
  perPage,
  searchInput = "",
  startDate = "",
  endDate = "",
  operatorId = ""
) {
  return (dispatch) => {
    dispatch(request());
    return orderService
      .ordersList(pageID, perPage, searchInput, startDate, endDate, operatorId)
      .then(
        (response) => {
          dispatch(
            success(response.data.body.orders, response.data.body.data.total)
          );
        },
        (error) => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: orderConstants.GETALL_REQUEST };
  }
  function success(items, total) {
    return { type: orderConstants.GETALL_SUCCESS, items, total };
  }
  function failure(error) {
    return { type: orderConstants.GETALL_FAILURE, error };
  }
}

/*
ACTION: Order Data
*/
function orderData(orderID) {
  return (dispatch) => {
    dispatch(request());
    return orderService.orderData(orderID).then(
      (response) => {
        dispatch(success(response.data.body));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: orderConstants.GET_REQUEST };
  }
  function success(response) {
    return { type: orderConstants.GET_SUCCESS, response };
  }
  function failure(error) {
    return { type: orderConstants.GET_FAILURE, error };
  }
}

/*
ACTION: Order Payments
*/
function orderPayments(orderID) {
  return (dispatch) => {
    dispatch(request());
    return orderService.orderPayments(orderID).then(
      (response) => {
        dispatch(success(response.data.body));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: orderConstants.GET_PAYMENTS_REQUEST };
  }
  function success(response) {
    return { type: orderConstants.GET_PAYMENTS_SUCCESS, response };
  }
  function failure(error) {
    return { type: orderConstants.GET_PAYMENTS_FAILURE, error };
  }
}

/*
ACTION: Update Status
*/
function orderUpdate(addToast, orderID, newStatus) {
  return (dispatch) => {
    dispatch(request());
    return orderService.orderUpdate(orderID, newStatus).then(
      (response) => {
        addToast("وضیعت سفارش با موفقیت بروزرسانی شد.", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(success(response.status));
      },
      (error) => {
        if (typeof error === "object" && addToast) {
          Object.keys(error).map((key) => {
            addToast(error[key], { appearance: "error", autoDismiss: true });
          });
        }
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: orderConstants.UPDATE_REQUEST };
  }
  function success(status) {
    return { type: orderConstants.UPDATE_SUCCESS, status };
  }
  function failure(error) {
    return { type: orderConstants.UPDATE_FAILURE, error };
  }
}
